module.exports = __webpack_public_path__ + "img/square-caret-left.37a8397e.svg";